import * as Yup from 'yup';

export const NewPasswordValidation = Yup.object().shape({
    password: Yup.string()
        .required('Senha é obrigatória'),
    passwordConfirmation: Yup.string()
        .test('passwords-match', 'Senhas precisam ser iguais.', function (value) {
            return this.parent.password === value
        })
})
